import React from 'react';
import { Box, Typography, Alert, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { dateTimeFormatter } from '../configuration/Configuration';

const DepartmentDeactivated = () => {
  const { userType, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = '/';
    } catch (error) {
      console.error('Logout failed:', error);
      window.location.href = '/';
    }
  };

  // Show different messages based on whether user has other active departments
  const hasActiveDepartments = userType?.hasActiveDepartments;
  const deletedDepartments = userType?.deletedDepartments || [];
  const activeDepartments = userType?.activeDepartments || [];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: 3,
        gap: 3
      }}
    >
      <Alert severity={hasActiveDepartments ? "info" : "warning"} sx={{ width: '100%', maxWidth: 600 }}>
        <Typography variant="h6" gutterBottom>
          {hasActiveDepartments ? "Department(s) Deactivated" : "All Departments Deactivated"}
        </Typography>
        
        {hasActiveDepartments ? (
          <>
            <Typography variant="body1" paragraph>
              Some of your departments have been deactivated by a tender manager, but you still have access through your active departments.
            </Typography>
            
            {deletedDepartments.length > 0 && (
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Deactivated departments:</strong>
                <br />
                {deletedDepartments.map((dept, index) => (
                  <span key={index}>
                    • {dept.name}
                    {dept.deleted_at && ` (deactivated on ${dateTimeFormatter({ value: dept.deleted_at })})`}
                    <br />
                  </span>
                ))}
              </Typography>
            )}
            
            {activeDepartments.length > 0 && (
              <Typography variant="body2" color="success.main" paragraph>
                <strong>Active departments:</strong>
                <br />
                {activeDepartments.map((dept, index) => (
                  <span key={index}>• {dept.name}<br /></span>
                ))}
              </Typography>
            )}
            
            <Typography variant="body2" color="text.secondary">
              You can still view tenders that were created before your departments were deactivated.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body1" paragraph>
              All your departments have been deactivated by a tender manager.
            </Typography>
            
            {deletedDepartments.length > 0 && (
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Deactivated departments:</strong>
                <br />
                {deletedDepartments.map((dept, index) => (
                  <span key={index}>
                    • {dept.name}
                    {dept.deleted_at && ` (deactivated on ${dateTimeFormatter({ value: dept.deleted_at })})`}
                    <br />
                  </span>
                ))}
              </Typography>
            )}
            
            <Typography variant="body2" color="text.secondary">
              You can still view tenders that were created before your departments were deactivated.
              Please contact your system administrator for more information.
            </Typography>
          </>
        )}
      </Alert>
      
      <Button 
        variant="outlined" 
        onClick={handleLogout}
        sx={{ mt: 2 }}
      >
        Logout
      </Button>
    </Box>
  );
};

export default DepartmentDeactivated;
